import Config from "../config/Config"
import "pixi-assetslist-loader"
import * as PIXI from "pixi.js"
import * as WebFont from "webfontloader";
import Signals from "../signals/GameSignals";

export default class ApplicationLoader {

    loadPreloadingAssets() {
        PIXI.Loader.shared.add("./assets/json/PreloaderAssets.json");
        PIXI.Loader.shared.onComplete.once(this.onLoadPreloadingAssetsComplete)
        PIXI.Loader.shared.load()
    }

    loadMainGameAssets() {
        PIXI.Loader.shared.add("./assets/json/AssetsConfig.json");
        PIXI.Loader.shared.onComplete.once(this.onLoadMainGameAssetsComplete)
        PIXI.Loader.shared.onProgress.add((e) => {
            Signals.loadingProgress.dispatch(e.progress)
        })
        PIXI.Loader.shared.load()
    }

//private
    onLoadPreloadingAssetsComplete = () => {
        Config.pattern = PIXI.Loader.shared.resources['pattern'].data
        Signals.preloaderAssetsLoadingComplete.dispatch()
    }

//private
    onLoadMainGameAssetsComplete = () => {
        //Config.pattern = PIXI.Loader.shared.resources['pattern'].data
        const entries = Object.entries(PIXI.Loader.shared.resources)
        this.textures = []
        for (let i = 0; i < entries.length; i++) {
            let res = entries[i][1]
            if (res.texture) {
                this.textures.push(res.texture)
            }
        }

        this.prepare(this.textures, 0)
    }

    //private
    loadFonts(fonts, fontsPath) {
        let process = 88;
        Signals.loadingProgress.dispatch(process)

        WebFont.load({
            custom: {
                families: fonts,
                urls: [fontsPath]
            },
            active: (event) => {
                Signals.loadingProgress.dispatch(100)
                setTimeout(() => {
                    Signals.mainGameAssetsLoadingComplete.dispatch()
                }, 1500); //1500
            },
            fontloading: (familyName, fvd) => {
                process += 3;
                Signals.loadingProgress.dispatch(process)
            }
        });
    }

//private
    prepare = (textures, index) => {
        Config.app.renderer.plugins.prepare.upload(textures[index], () => {
            if (index + 1 <= this.textures.length - 1) {
                this.prepare(textures, index + 1)
            } else {
                this.loadFonts(Config.fonts, Config.fontsPath)
                //Signals.mainGameAssetsLoadingComplete.dispatch()
            }
        });
    }

}
